// Module générique de sommaire cliquable, construit à partir des H2 d'un
// bloc de contenu. Réutilisable sur tout type de page (légal, blog, ...) :
// ne modifie jamais le contenu source, se limite à lire les H2 et à
// insérer une nav à côté.
window.ClebsToc = {
  // options: { layout, title, content, label }
  // layout  : élément à transformer en grille 12 colonnes (.clebs-toc-layout)
  // title   : élément H1 de la page (.clebs-toc-layout__title)
  // content : élément contenant les H2 (.clebs-toc-layout__content)
  // label   : libellé du sommaire (défaut "Sommaire")
  build(options) {
    const { layout, title, content, label = 'Sommaire' } = options;
    if (!layout || !title || !content) return null;

    const headings = Array.from(content.querySelectorAll('h2'));
    if (headings.length === 0) return null;

    const slugify = (text, index) => {
      const base = text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      return base || `section-${index}`;
    };

    const usedIds = new Set();
    const links = headings.map((heading, index) => {
      if (!heading.id) {
        let id = slugify(heading.textContent.trim(), index);
        while (usedIds.has(id)) id = `${id}-${index}`;
        heading.id = id;
      }
      usedIds.add(heading.id);
      heading.classList.add('clebs-toc-target');
      return { id: heading.id, text: heading.textContent.trim() };
    });

    const nav = document.createElement('nav');
    nav.className = 'clebs-toc';
    nav.setAttribute('aria-label', label);

    const navTitle = document.createElement('p');
    navTitle.className = 'clebs-toc__title';
    navTitle.textContent = label;
    nav.appendChild(navTitle);

    const list = document.createElement('ul');
    list.className = 'clebs-toc__list';
    links.forEach(({ id, text }) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = text;
      item.appendChild(link);
      list.appendChild(item);
    });
    nav.appendChild(list);

    layout.classList.add('clebs-toc-layout');
    title.classList.add('clebs-toc-layout__title');
    content.classList.add('clebs-toc-layout__content');
    layout.insertBefore(nav, content);

    return nav;
  },
};
